// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { AtBatEventDataWire, AtBatEventDataWireT } from '../mannequin/at-bat-event-data-wire';
import { BattingOrderEventDataWire, BattingOrderEventDataWireT } from '../mannequin/batting-order-event-data-wire';
import { CountEventDataWire, CountEventDataWireT } from '../mannequin/count-event-data-wire';
import { GameEventDataWire, unionToGameEventDataWire, unionListToGameEventDataWire } from '../mannequin/game-event-data-wire';
import { GumboTimecodeEventDataWire, GumboTimecodeEventDataWireT } from '../mannequin/gumbo-timecode-event-data-wire';
import { HandedEventDataWire, HandedEventDataWireT } from '../mannequin/handed-event-data-wire';
import { InningEventDataWire, InningEventDataWireT } from '../mannequin/inning-event-data-wire';
import { LiveActionEventDataWire, LiveActionEventDataWireT } from '../mannequin/live-action-event-data-wire';
import { OptionalBool } from '../mannequin/optional-bool';
import { PlayEventDataWire, PlayEventDataWireT } from '../mannequin/play-event-data-wire';
import { PositionAssignmentEventDataWire, PositionAssignmentEventDataWireT } from '../mannequin/position-assignment-event-data-wire';
import { TeamScoreEventDataWire, TeamScoreEventDataWireT } from '../mannequin/team-score-event-data-wire';


export class GameEventWire implements flatbuffers.IUnpackableObject<GameEventWireT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):GameEventWire {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsGameEventWire(bb:flatbuffers.ByteBuffer, obj?:GameEventWire):GameEventWire {
  return (obj || new GameEventWire()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsGameEventWire(bb:flatbuffers.ByteBuffer, obj?:GameEventWire):GameEventWire {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new GameEventWire()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

dataType():GameEventDataWire {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint8(this.bb_pos + offset) : GameEventDataWire.NONE;
}

data<T extends flatbuffers.Table>(obj:any):any|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
}

time():number {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.readFloat64(this.bb_pos + offset) : 0.0;
}

isKeyFramed():OptionalBool {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.readInt8(this.bb_pos + offset) : OptionalBool.False;
}

static startGameEventWire(builder:flatbuffers.Builder) {
  builder.startObject(4);
}

static addDataType(builder:flatbuffers.Builder, dataType:GameEventDataWire) {
  builder.addFieldInt8(0, dataType, GameEventDataWire.NONE);
}

static addData(builder:flatbuffers.Builder, dataOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, dataOffset, 0);
}

static addTime(builder:flatbuffers.Builder, time:number) {
  builder.addFieldFloat64(2, time, 0.0);
}

static addIsKeyFramed(builder:flatbuffers.Builder, isKeyFramed:OptionalBool) {
  builder.addFieldInt8(3, isKeyFramed, OptionalBool.False);
}

static endGameEventWire(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createGameEventWire(builder:flatbuffers.Builder, dataType:GameEventDataWire, dataOffset:flatbuffers.Offset, time:number, isKeyFramed:OptionalBool):flatbuffers.Offset {
  GameEventWire.startGameEventWire(builder);
  GameEventWire.addDataType(builder, dataType);
  GameEventWire.addData(builder, dataOffset);
  GameEventWire.addTime(builder, time);
  GameEventWire.addIsKeyFramed(builder, isKeyFramed);
  return GameEventWire.endGameEventWire(builder);
}

unpack(): GameEventWireT {
  return new GameEventWireT(
    this.dataType(),
    (() => {
      const temp = unionToGameEventDataWire(this.dataType(), this.data.bind(this));
      if(temp === null) { return null; }
      return temp.unpack()
  })(),
    this.time(),
    this.isKeyFramed()
  );
}


unpackTo(_o: GameEventWireT): void {
  _o.dataType = this.dataType();
  _o.data = (() => {
      const temp = unionToGameEventDataWire(this.dataType(), this.data.bind(this));
      if(temp === null) { return null; }
      return temp.unpack()
  })();
  _o.time = this.time();
  _o.isKeyFramed = this.isKeyFramed();
}
}

export class GameEventWireT implements flatbuffers.IGeneratedObject {
constructor(
  public dataType: GameEventDataWire = GameEventDataWire.NONE,
  public data: AtBatEventDataWireT|BattingOrderEventDataWireT|CountEventDataWireT|GumboTimecodeEventDataWireT|HandedEventDataWireT|InningEventDataWireT|LiveActionEventDataWireT|PlayEventDataWireT|PositionAssignmentEventDataWireT|TeamScoreEventDataWireT|null = null,
  public time: number = 0.0,
  public isKeyFramed: OptionalBool = OptionalBool.False
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const data = builder.createObjectOffset(this.data);

  return GameEventWire.createGameEventWire(builder,
    this.dataType,
    data,
    this.time,
    this.isKeyFramed
  );
}
}
